import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Modal, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

import styles from './SuccessModal.module.scss';

export const SuccessModal = ({
	handleClose,
	open,
	title,
	render_title,
	pincode,
}) => (
	<Modal open={open} onClose={handleClose}>
		<div className={styles.container}>
			<div className={clsx(styles.title, 'largeFont')}>
				<div className={styles.headerofModal}>
					<span className={styles.titlecontainer}>
						{' '}
						<ThumbUpIcon className={styles.block} fontSize="1rem" />
					</span>
					<span className={styles.txt}>Success</span>
				</div>
				<CloseIcon
					className={styles.crossBlock}
					fontSize="1rem"
					onClick={handleClose}
				/>
			</div>
			<Box bgcolor="#dadada3d" height="auto" margin="15px" padding="20px">
				<p className={clsx(styles.warningText, 'largeFont')}>
					{title}
					{render_title ? render_title : null}
					{pincode && <span>PinCode:{pincode}</span>}
				</p>
			</Box>
		</div>
	</Modal>
);

SuccessModal.propTypes = {
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	pincode: PropTypes.string,
	title: PropTypes.string,
	render_title: PropTypes.string,
};
